var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 114,
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_319_239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.8809 37.5108C52.995 28.3366 55.552 23.7495 59.375 23.7495C63.198 23.7495 65.755 28.3366 70.8691 37.5108L72.1922 39.8843C73.6454 42.4913 74.3721 43.7948 75.505 44.6549C76.638 45.515 78.049 45.8342 80.8711 46.4728L83.4404 47.0541C93.3713 49.3011 98.3368 50.4245 99.5182 54.2235C100.7 58.0224 97.3144 61.9809 90.5441 69.8978L88.7925 71.946C86.8687 74.1958 85.9067 75.3207 85.474 76.7123C85.0412 78.1039 85.1866 79.6047 85.4775 82.6064L85.7423 85.3391C86.7659 95.902 87.2777 101.184 84.1848 103.531C81.092 105.879 76.4428 103.739 67.1445 99.4574L64.7389 98.3497C62.0966 97.1331 60.7754 96.5248 59.375 96.5248C57.9746 96.5248 56.6534 97.1331 54.0111 98.3497L51.6055 99.4574C42.3072 103.739 37.658 105.879 34.5652 103.531C31.4723 101.184 31.9841 95.9021 33.0077 85.3391L33.2725 82.6064C33.5634 79.6047 33.7088 78.1039 33.276 76.7123C32.8433 75.3207 31.8813 74.1958 29.9574 71.946L28.2059 69.8978C21.4356 61.9809 18.0505 58.0224 19.2318 54.2235C20.4132 50.4245 25.3787 49.3011 35.3096 47.0541L37.8789 46.4728C40.701 45.8342 42.112 45.515 43.245 44.6549C44.3779 43.7948 45.1046 42.4913 46.5578 39.8843L47.8809 37.5108Z",
    fill: "url(#paint0_linear_319_239)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1195 11.8765C23.262 11.3741 24.1538 11.3711 24.2997 11.8725C24.9657 14.1626 26.2005 17.5475 28.0679 19.4023C29.9352 21.2571 33.3284 22.469 35.6229 23.1195C36.1254 23.262 36.1284 24.1538 35.6269 24.2997C33.3368 24.9657 29.9519 26.2005 28.0971 28.0679C26.2424 29.9352 25.0304 33.3284 24.3799 35.6229C24.2375 36.1254 23.3456 36.1284 23.1997 35.6269C22.5338 33.3368 21.2989 29.9519 19.4316 28.0971C17.5642 26.2424 14.171 25.0304 11.8765 24.3799C11.3741 24.2375 11.3711 23.3456 11.8725 23.1997C14.1626 22.5338 17.5475 21.2989 19.4023 19.4315C21.2571 17.5642 22.469 14.171 23.1195 11.8765Z",
    fill: "url(#paint1_linear_319_239)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.25 15.437C92.2175 15.437 93.8125 17.032 93.8125 18.9995V20.187H95C96.9675 20.187 98.5625 21.782 98.5625 23.7495C98.5625 25.717 96.9675 27.312 95 27.312H93.8125V28.4995C93.8125 30.467 92.2175 32.062 90.25 32.062C88.2825 32.062 86.6875 30.467 86.6875 28.4995V27.312H85.5C83.5325 27.312 81.9375 25.717 81.9375 23.7495C81.9375 21.782 83.5325 20.187 85.5 20.187H86.6875V18.9995C86.6875 17.032 88.2825 15.437 90.25 15.437Z",
    fill: "url(#paint2_linear_319_239)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_319_239",
    x: 0,
    y: -3.00049,
    width: 114,
    height: 117,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.55
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_319_239"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_319_239",
    x1: 22.6506,
    y1: 35.4196,
    x2: 108.424,
    y2: 48.7688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_319_239",
    x1: 12.6058,
    y1: 15.0393,
    x2: 38.6334,
    y2: 19.0901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_319_239",
    x1: 82.6891,
    y1: 17.8397,
    x2: 100.348,
    y2: 20.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg2);
export default __webpack_public_path__ + "static/media/img2.e6d7a3d9a519b8a8dbcf80ab09d540f2.svg";
export { ForwardRef as ReactComponent };